import { render, staticRenderFns } from "./CreateRI.vue?vue&type=template&id=5ef8882e"
import script from "./CreateRI.vue?vue&type=script&lang=js"
export * from "./CreateRI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports